import { autoinject, transient } from "aurelia-dependency-injection";
import { OnboardingConfigModel } from "../../../../../../models/onboarding/onboarding.models";
import { ChildComponent } from "../../../../modules/child-component";
import { PropertyMetaModel } from "../../../../../../models/basics/basics.models";
import { FormMetaConfig } from "../../../../../components/editors/form-editor/form-meta-config";
import { useView } from "aurelia-framework";

@autoinject()
@transient()
@useView('views/pages/admin/onboarding/steps/oboarding-basic-meta/basic-meta.html')
export class OnboardingBasicMeta extends ChildComponent<OnboardingConfigModel>
{
    public additionalData: { [key: string]: any } = { };
    public variables: PropertyMetaModel[] = [];
    public basicMetaConfig: string | FormMetaConfig;
    public sections: string[];

    activate(model: { item: OnboardingConfigModel, variables: PropertyMetaModel[], sections: string[] }) {
        super.activate(model.item);
        this.variables = model.variables;
        this.sections = model.sections;
        this.basicMetaConfig = this.item.isBasicMetaFormStyle ? JSON.parse(this.item.basicMetaConfig) : this.item.basicMetaConfig;
        if (this.item.isBasicMetaFormStyle) {
            if (!this.basicMetaConfig) {
                this.basicMetaConfig = { pages: [] };
            }
            const config = <FormMetaConfig>this.basicMetaConfig;
            if (!config.pages) {
                config.pages = [];
            }
        }

        this.additionalData['pluginId'] = model.item.onboardingPluginId;
        this.additionalData['entityTypeId'] = model.item.onboardingPluginEntityTypeId;
    }

    onStyleChanged() {
        if (this.item.isBasicMetaFormStyle) {
            this.basicMetaConfig = { pages: [] };
        } else {
            this.basicMetaConfig = null;
        }
    }

    unbind() {
        if (this.item.isBasicMetaFormStyle) {
            this.item.basicMetaConfig = JSON.stringify(this.basicMetaConfig);
        } else if (typeof this.basicMetaConfig == 'string') {
            this.item.basicMetaConfig = this.basicMetaConfig;
        }
    }
}
